import { use } from 'react'

import { SchemaFormConfigureContext } from '../contexts/ConfigureContext'

export const usePlaceholder = () => {
  return use(SchemaFormConfigureContext).placeholder
}
